import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "consent-banner"
}
const _hoisted_2 = { class: "consent-content" }
const _hoisted_3 = { class: "consent-text" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "consent-actions" }

import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import type { SupportedLocale } from '@/i18n/types';

interface ConsentChoice {
  action: 'accept' | 'decline';
  timestamp: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ConsentBanner',
  props: {
  privacyPolicyUrl: {
    type: String,
    default: ''
  }
},
  emits: ["consentGiven"],
  setup(__props, { emit: __emit }) {

const { t, locale } = useI18n();
const props = __props;

const showBanner = ref(false);

const emit = __emit;

const changeLanguage = (lang: SupportedLocale): void => {
  locale.value = lang
}

// Check if we should show the banner
const checkShouldShowBanner = (): boolean => {
  const urlParams = new URLSearchParams(window.location.search);
  const appOptIn = urlParams.get('trackingOptIn');
  const appLocale = urlParams.get('locale');
  if (appLocale && ['en', 'es', 'de'].includes(appLocale)) {
    locale.value = appLocale as SupportedLocale
  }

  if(!window.ReactNativeWebView) {
    // If not in WebView, check local storage
    const storedOptIn = localStorage.getItem('trackingOptIn');
    return storedOptIn === null || storedOptIn === 'undefined' || storedOptIn === 'null';
  }
  
  // If appOptIn is null or undefined, user hasn't made a choice yet
  // If it's 'false', user has explicitly declined
  // If it's 'true', user has accepted
  return appOptIn === null || appOptIn === 'undefined' || appOptIn === 'null';
};

const handleAccept = () => {
  const choice: ConsentChoice = {
    action: 'accept',
    timestamp: new Date().toISOString()
  };
  
  // Set local storage to remember user's choice
  localStorage.setItem('trackingOptIn', 'true');

  // Send message to React Native
  sendConsentToApp(choice);
  
  // Hide banner
  showBanner.value = false;
  
  // Emit event for parent component
  emit('consentGiven', choice);
};

const handleDecline = () => {
  const choice: ConsentChoice = {
    action: 'decline',
    timestamp: new Date().toISOString()
  };

  // Set local storage to remember user's choice
  localStorage.setItem('trackingOptIn', 'false');
  
  // Send message to React Native
  sendConsentToApp(choice);
  
  // Hide banner
  showBanner.value = false;
  
  // Emit event for parent component
  emit('consentGiven', choice);
};

const sendConsentToApp = (choice: ConsentChoice) => {
  // Send message to React Native WebView
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify({
      type: 'CONSENT_CHOICE',
      payload: choice
    }));
  }
};

onMounted(() => {
  // Small delay to ensure URL params are loaded
  setTimeout(() => {
    showBanner.value = checkShouldShowBanner();
  }, 100);
});

return (_ctx: any,_cache: any) => {
  return (showBanner.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", null, _toDisplayString(_unref(t)('consent.title')), 1),
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_unref(t)('consent.descriptionStart')) + " ", 1),
              _createElementVNode("a", {
                href: __props.privacyPolicyUrl,
                target: "_blank",
                class: "privacy-link"
              }, _toDisplayString(_unref(t)('consent.privacyLinkText')), 9, _hoisted_4),
              _createTextVNode(" " + _toDisplayString(_unref(t)('consent.descriptionEnd')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: handleAccept,
              class: "consent-btn consent-btn-accept"
            }, _toDisplayString(_unref(t)('consent.accept')), 1),
            _createElementVNode("button", {
              onClick: handleDecline,
              class: "consent-btn consent-btn-decline"
            }, _toDisplayString(_unref(t)('consent.decline')), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})